var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugType2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.71,
    height: 24.11,
    viewBox: "0 0 27.71 24.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56.76h15.3s5.1,0,5.1,8.6c0,11.3-5.3,14-13.1,14S.76,20,.76,10.26C.86,2,6.56.76,6.56.76Z",
    fill: "none",
    stroke: "#414042",
    strokeWidth: 1.51
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.76,
    cy: 10.56,
    r: 1.7,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.66,
    cy: 16.56,
    r: 1.7,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.26,
    cy: 16.56,
    r: 1.7,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.16,
    cy: 10.46,
    r: 1.7,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.96,
    cy: 10.36,
    r: 2.6,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.96,
    cy: 6.16,
    r: 1,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.96,
    cy: 5.96,
    r: 1,
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType2);
export default __webpack_public_path__ + "static/media/plugType2.5c9635f9d0d7f13733d5f4cb63e2b2d7.svg";
export { ForwardRef as ReactComponent };